/* eslint-disable react/destructuring-assignment */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import { NavLink } from 'react-router-dom';
import { FaPaperPlane } from 'react-icons/fa';
import {
  IoRocketSharp,
} from 'react-icons/io5';
import { GoRocket } from 'react-icons/go';
import { RiRocket2Fill } from 'react-icons/ri';
import activeNodeImg from '../../images/active-nlw.png';
import inActiveNodeImg from '../../images/inactive-nlw.png';
import { prefixPath } from '../../utils/helpers';
import numberFormatter from '../../utils/formatter';

interface customData {
    availableEndpoint: number,
    subscriptionId: string,
    configItemCode:string,
    consumedCount: number,
    totalUnit: number,
    cardType: string,
    planName: string,
    totalEndpoint: number,
}
const SubscribedEndpoint = ({
  availableEndpoint,
  subscriptionId,
  configItemCode,
  consumedCount,
  totalUnit,
  cardType,
  planName,
  totalEndpoint,
}: customData) => {
  const setImage = (val: string) => {
    if (!val) {
      return '';
    }
    if (val.includes(' ')) {
      // eslint-disable-next-line prefer-destructuring, no-param-reassign
      val = val.split(' ')[1];
    }
    switch (val.toLowerCase()) {
      case 'build': return <GoRocket size={40} className="mt-1 mb-2 text-primary" />;
      case 'growth': return <IoRocketSharp size={40} className="mt-1 mb-2  text-danger" />;
      case 'developer': return <FaPaperPlane size={40} className="mt-1 mb-2 text-muted" />;
      case 'launch': return <RiRocket2Fill size={40} className="mt-1 mb-2  text-primary" />;
      case 'corda': return (<img src="../images/protocols/logos/corda_logo.svg" height="25px" alt="" />);
      case 'ethereum': return (<img src="../images/protocols/logos/ethereum_logo.svg" height="25px" alt="" />);
      case 'credit': return (<img src="../images/protocols/logos/credits.png" height="25px" alt="" />);
      case 'fabric': return (<img src="../images/protocols/logos/Hyperledger-Fabric_logo.svg" height="25px" alt="" />);
      case 'sawtooth': return (<img src="../images/protocols/logos/sawtooth_logo.svg" height="25px" alt="" />);
      case 'fluree': return (<img src="../images/protocols/logos/fluree_logo.svg" height="25px" alt="" />);
      case 'phaeton': return (<img src="../images/protocols/logos/phaeton_logo.svg" height="25px" alt="" />);
      case 'polygon': return (<img src="../images/protocols/logos/Polygonpos_logo.svg" height="25px" alt="" />);
      case 'binance': return (<img src="../images/protocols/logos/binance_logo.svg" height="25px" alt="" />);
      case 'tron': return (<img src="../images/protocols/logos/tron_logo.svg" height="25px" alt="" />);
      case 'avalanche': return (<img src="../images/protocols/logos/avalanche_logo.svg" height="25px" alt="" />);
      case 'axia': return (<img src="../images/protocols/logos/axia_logo.svg" height="25px" alt="" />);
      case 'fantom': return (<img src="../images/protocols/logos/Fantom_logo.svg" height="25px" alt="" />);
      case 'energy-web': return (<img src="../images/protocols/logos/Energy_Web_Logo.svg" height="25px" alt="" />);
      case 'enterprise': return (<img src="../images/protocols/logos/corda_logo.svg" height="25px" alt="" />);
      case 'blockchain': return (<img src="../images/protocols/logos/provenance_blockchain_logo.svg" height="25px" alt="" />);
      case 'avalanche-subnets': return (<img src="../images/protocols/logos/avalanche_logo.svg" height="25px" alt="" />);
      case 'bahamut': return (<img src="../images/protocols/logos/fastex_logo.svg" height="25px" alt="" />);
      case 'zksyncera': return (<img src="../images/protocols/logos/zksyncera_logo.svg" height="25px" alt="" />);
      case 'opstack': return (<img src="../images/protocols/logos/opstack_logo.svg" height="25px" alt="" />);
      case 'orbit': return (<img src="../images/protocols/logos/arbitrum_orbit_logo.svg" height="25px" alt="" />);
      case 'subsquid': return (<img src="../images/protocols/logos/subsquid-logo-dark.svg" height="25px" alt="" />);

      default: return '';
    }
  };
  const getUrl = () => {
    if (cardType === 'public') {
      return prefixPath(`/endpoint/create?subsId=${subscriptionId}&plan=${planName}`);
    }
    return '';
  };
  return (
        <div className="col-lg-4 col-xl-3 col-md-6 col-sm-12 mt-5 effectCard cursor">
            <NavLink to={getUrl()} className="nonActiveTextColor" style={{ textDecoration: 'none' }}>
                <div className="card workSpaceCard" style={{ height: '100%' }}>
                    <div className="card-body">
                        <div className="d-flex justify-content-left">
                                {setImage(configItemCode)}
                        <span className="ps-3 py-3 fs-6 text-muted text-wrap">{subscriptionId}</span>
                        </div>
                        <div className="mt-1 mb-3 a-tag">
                            <span className="fs-5">{planName}</span>
                        </div>
                        <div className="mt-2 a-tag">
                        <div className="d-flex align-items-center">
                            <div className="col-2 me-2">
                                <img className="mx-1" src={activeNodeImg} alt="" />
                            </div>
                            <div className="col-7 my-auto ms-1">Consumed Units</div>
                            <div className="col-3 my-auto">
                                <strong>{numberFormatter(consumedCount)}</strong>
                            </div>
                        </div>
                        </div>
                    <div className="mt-3 mb-1 a-tag">
                        <div className="d-flex align-items-center">
                            <div className="col-2 me-2">
                                <img className="mx-1" src={inActiveNodeImg} alt="" />
                            </div>
                            <div className="col-7 my-auto ms-1">Total API Units</div>
                            <div className="col-3 my-auto">
                                <strong>{numberFormatter(totalUnit)}</strong>
                            </div>
                        </div>
                    </div>
                    </div>
                    <div className="card-footer a-tag">
                        <div className="d-flex mt-1">
                            <div className="col-10">
                                <p className="mb-1">
                                    <span>RPC Endpoints Available:</span>
                                    <strong className="mx-2">
                                        {availableEndpoint}
                                        /
                                        {totalEndpoint}
                                    </strong>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </NavLink>
        </div>
  );
};

export default SubscribedEndpoint;
